var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.baseData)?_c('detail-page',{attrs:{"title":"Thông tin đơn hàng","base-data":_vm.baseData,"back-link":_vm.backLink,"scaffolding":_vm.scaffolding,"mode":_vm.mode,"canSubmit":false}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }